
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ameegos/local",
      function () {
        return require("private-next-pages/ameegos/local.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ameegos/local"])
      });
    }
  